function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// history
(function (window, factory) {
  // universal module definition
  if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('./core'), require('fizzy-ui-utils'));
  } else {
    // browser global
    factory(window, window.InfiniteScroll, window.fizzyUIUtils);
  }
})(window, function factory(window, InfiniteScroll, utils) {
  var proto = InfiniteScroll.prototype;
  Object.assign(InfiniteScroll.defaults, {
    history: 'replace' // historyTitle: false,

  });
  var link = document.createElement('a'); // ----- create/destroy ----- //

  InfiniteScroll.create.history = function () {
    if (!this.options.history) return; // check for same origin

    link.href = this.getAbsolutePath(); // MS Edge does not have origin on link
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12236493/

    var linkOrigin = link.origin || link.protocol + '//' + link.host;
    var isSameOrigin = linkOrigin == location.origin;

    if (!isSameOrigin) {
      console.error('[InfiniteScroll] cannot set history with different origin: ' + "".concat(link.origin, " on ").concat(location.origin, " . History behavior disabled."));
      return;
    } // two ways to handle changing history


    if (this.options.append) {
      this.createHistoryAppend();
    } else {
      this.createHistoryPageLoad();
    }
  };

  proto.createHistoryAppend = function () {
    this.updateMeasurements();
    this.updateScroller(); // array of scroll positions of appended pages

    this.scrollPages = [// first page
    {
      top: 0,
      path: location.href,
      title: document.title
    }];
    this.scrollPage = this.scrollPages[0]; // events

    this.scrollHistoryHandler = this.onScrollHistory.bind(this);
    this.unloadHandler = this.onUnload.bind(this);
    this.scroller.addEventListener('scroll', this.scrollHistoryHandler);
    this.on('append', this.onAppendHistory);
    this.bindHistoryAppendEvents(true);
  };

  proto.bindHistoryAppendEvents = function (isBind) {
    var addRemove = isBind ? 'addEventListener' : 'removeEventListener';
    this.scroller[addRemove]('scroll', this.scrollHistoryHandler);
    window[addRemove]('unload', this.unloadHandler);
  };

  proto.createHistoryPageLoad = function () {
    this.on('load', this.onPageLoadHistory);
  };

  InfiniteScroll.destroy.history = proto.destroyHistory = function () {
    var isHistoryAppend = this.options.history && this.options.append;

    if (isHistoryAppend) {
      this.bindHistoryAppendEvents(false);
    }
  }; // ----- append history ----- //


  proto.onAppendHistory = function (response, path, items) {
    // do not proceed if no items. #779
    if (!items || !items.length) return;
    var firstItem = items[0];
    var elemScrollY = this.getElementScrollY(firstItem); // resolve path

    link.href = path; // add page data to hash

    this.scrollPages.push({
      top: elemScrollY,
      path: link.href,
      title: response.title
    });
  };

  proto.getElementScrollY = function (elem) {
    if (this.options.elementScroll) {
      return elem.offsetTop - this.top;
    } else {
      var rect = elem.getBoundingClientRect();
      return rect.top + window.scrollY;
    }
  };

  proto.onScrollHistory = function () {
    // cycle through positions, find biggest without going over
    var scrollPage = this.getClosestScrollPage(); // set history if changed

    if (scrollPage != this.scrollPage) {
      this.scrollPage = scrollPage;
      this.setHistory(scrollPage.title, scrollPage.path);
    }
  };

  utils.debounceMethod(InfiniteScroll, 'onScrollHistory', 150);

  proto.getClosestScrollPage = function () {
    var scrollViewY;

    if (this.options.elementScroll) {
      scrollViewY = this.scroller.scrollTop + this.scroller.clientHeight / 2;
    } else {
      scrollViewY = window.scrollY + this.windowHeight / 2;
    }

    var scrollPage;

    var _iterator = _createForOfIteratorHelper(this.scrollPages),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var page = _step.value;
        if (page.top >= scrollViewY) break;
        scrollPage = page;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return scrollPage;
  };

  proto.setHistory = function (title, path) {
    var optHistory = this.options.history;
    var historyMethod = optHistory && history[optHistory + 'State'];
    if (!historyMethod) return;
    history[optHistory + 'State'](null, title, path);
    if (this.options.historyTitle) document.title = title;
    this.dispatchEvent('history', null, [title, path]);
  }; // scroll to top to prevent initial scroll-reset after page refresh
  // https://stackoverflow.com/a/18633915/182183


  proto.onUnload = function () {
    if (this.scrollPage.top === 0) return; // calculate where scroll position would be on refresh

    var scrollY = window.scrollY - this.scrollPage.top + this.top; // disable scroll event before setting scroll #679

    this.destroyHistory();
    scrollTo(0, scrollY);
  }; // ----- load history ----- //
  // update URL


  proto.onPageLoadHistory = function (response, path) {
    this.setHistory(response.title, path);
  }; // --------------------------  -------------------------- //


  return InfiniteScroll;
});